'use client';

import { c as _c } from "react/compiler-runtime";
import ImgWrapper from '@components/img-wrapper/ImgWrapper';
import Portal from '@components/portal/Portal';
import { handleVisibleHeader } from '@lib/store/slices/ComponentsSlice';
import useMousePosition from '@lib/tools/hooks/useMousePosition';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import GallerySliderModal from 'src/app/gallery/components/gallery-slider-modal/GallerySliderModal';
import GallerySliderModalMobile from 'src/app/gallery/components/gallery-slider-modal/GallerySliderModalMobile';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import style from './ProgressPhotosSlider.module.scss';
const normalizeUrl = url => url?.replace(/ /g, '%20').replace('http://', 'https://');
const ArrowPrevIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.876367 6.49105C0.605168 6.21985 0.605168 5.78015 0.876367 5.50895L5.29578 1.08954C5.56698 0.81834 6.00668 0.81834 6.27788 1.08954C6.54907 1.36073 6.54907 1.80043 6.27788 2.07163L2.34951 6L6.27788 9.92837C6.54907 10.1996 6.54907 10.6393 6.27788 10.9105C6.00668 11.1817 5.56698 11.1817 5.29578 10.9105L0.876367 6.49105ZM14.9443 6.69444L1.36741 6.69445L1.36741 5.30556L14.9443 5.30556L14.9443 6.69444Z" fill="#1C1C1C" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const ArrowNextIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1236 6.49105C14.3948 6.21985 14.3948 5.78015 14.1236 5.50895L9.70422 1.08954C9.43302 0.81834 8.99332 0.81834 8.72212 1.08954C8.45093 1.36073 8.45093 1.80043 8.72212 2.07163L12.6505 6L8.72212 9.92837C8.45093 10.1996 8.45093 10.6393 8.72212 10.9105C8.99332 11.1817 9.43302 11.1817 9.70422 10.9105L14.1236 6.49105ZM0.055664 6.69444L13.6326 6.69445L13.6326 5.30556L0.0556641 5.30556L0.055664 6.69444Z" fill="#1C1C1C" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const ZoomCursorIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.82" stroke="white" strokeWidth="1.36" /><path d="M37.9 43.5663H49.2334" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /><path d="M43.5667 49.2329V37.8996" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const ProgressPhotosSlider = t0 => {
  const $ = _c(56);
  const {
    images,
    isMobile
  } = t0;
  const dispatch = useDispatch();
  const [swiper, setSwiper] = useState(null);
  const [swiperActive, setSwiperActive] = useState(0);
  const [modalStatus, setModalStatus] = useState(false);
  const [cursorStatus, setCursorStatus] = useState(false);
  const [scale, setScale] = useState(1);
  const {
    x,
    y
  } = useMousePosition();
  const sliderArr = images.map(normalizeUrl);
  let t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== isMobile || $[2] !== modalStatus) {
    t1 = () => {
      if (!isMobile || !modalStatus) {
        return;
      }
      dispatch(handleVisibleHeader(false));
      return () => dispatch(handleVisibleHeader(true));
    };
    t2 = [dispatch, isMobile, modalStatus];
    $[0] = dispatch;
    $[1] = isMobile;
    $[2] = modalStatus;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[5] !== isMobile || $[6] !== modalStatus) {
    t3 = () => {
      if (isMobile || !modalStatus) {
        return;
      }
      const onKeyDown = event => {
        if (event.key === "Escape") {
          setModalStatus(false);
        }
      };
      document.addEventListener("keydown", onKeyDown);
      return () => document.removeEventListener("keydown", onKeyDown);
    };
    t4 = [isMobile, modalStatus];
    $[5] = isMobile;
    $[6] = modalStatus;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== swiper || $[10] !== swiperActive) {
    t5 = () => {
      if (!swiper || swiperActive <= 0) {
        return;
      }
      swiper.slidePrev();
    };
    $[9] = swiper;
    $[10] = swiperActive;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handlePrev = t5;
  const handleNext = () => {
    if (!swiper || swiperActive >= sliderArr.length - 1) {
      return;
    }
    swiper.slideNext();
  };
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setModalStatus(true);
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleOpenModal = t6;
  const navBtnClass = isMobile ? "gallery_swiper_mobile" : "gallery_swiper";
  const t7 = style;
  const T0 = Swiper;
  const t8 = 1;
  const t9 = true;
  const t10 = style;
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = instance => setSwiperActive(instance.activeIndex);
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== isMobile) {
    t12 = (url, idx) => <SwiperSlide key={`${url}-${idx}`} className={style.swiperSlide} onClick={handleOpenModal} onMouseEnter={() => {
      if (!isMobile) {
        setCursorStatus(true);
      }
    }} onMouseLeave={() => setCursorStatus(false)}><span className={cn(style.slideInner, {
        [style.slideInner_desktop]: !isMobile
      })}><ImgWrapper imgUrl={url} alt={"\u0414\u0438\u043D\u0430\u043C\u0438\u043A\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"} /><span className={style.gradient} /></span></SwiperSlide>;
    $[14] = isMobile;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const t13 = sliderArr.map(t12);
  const t14 = `swiper-button-prev ${navBtnClass}__prev`;
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ArrowPrevIcon />;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== handlePrev || $[18] !== t14) {
    t16 = <div className={t14} onClick={handlePrev} role="button" tabIndex="0" aria-label={"\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0435\u0435 \u0444\u043E\u0442\u043E"}>{t15}</div>;
    $[17] = handlePrev;
    $[18] = t14;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const t17 = swiperActive + 1;
  let t18;
  if ($[20] !== sliderArr.length || $[21] !== t17) {
    t18 = <div className={style.nav__counter}>{t17}/{sliderArr.length}</div>;
    $[20] = sliderArr.length;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  const t19 = `swiper-button-next ${navBtnClass}__next`;
  let t20;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <ArrowNextIcon />;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== handleNext || $[25] !== t19) {
    t21 = <div className={t19} onClick={handleNext} role="button" tabIndex="0" aria-label={"\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 \u0444\u043E\u0442\u043E"}>{t20}</div>;
    $[24] = handleNext;
    $[25] = t19;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== t16 || $[28] !== t18 || $[29] !== t21) {
    t22 = <div className={style.nav} onClick={_temp}>{t16}{t18}{t21}</div>;
    $[27] = t16;
    $[28] = t18;
    $[29] = t21;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] !== T0 || $[32] !== t10.swiper || $[33] !== t11 || $[34] !== t13 || $[35] !== t22) {
    t23 = <T0 onSwiper={setSwiper} slidesPerView={t8} allowTouchMove={t9} className={t10.swiper} onSlideChange={t11}>{t13}{t22}</T0>;
    $[31] = T0;
    $[32] = t10.swiper;
    $[33] = t11;
    $[34] = t13;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== cursorStatus || $[38] !== isMobile || $[39] !== modalStatus || $[40] !== x || $[41] !== y) {
    t24 = cursorStatus && !modalStatus && !isMobile && <Portal><div className={style.cursorImg} style={{
        left: x,
        top: y
      }}><ZoomCursorIcon /></div></Portal>;
    $[37] = cursorStatus;
    $[38] = isMobile;
    $[39] = modalStatus;
    $[40] = x;
    $[41] = y;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t23 || $[44] !== t24 || $[45] !== t7.photos) {
    t25 = <div className={t7.photos}>{t23}{t24}</div>;
    $[43] = t23;
    $[44] = t24;
    $[45] = t7.photos;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== isMobile || $[48] !== modalStatus || $[49] !== scale || $[50] !== sliderArr || $[51] !== swiperActive) {
    t26 = modalStatus && (isMobile ? <GallerySliderModalMobile swiperActive={swiperActive} setSwiperActive={setSwiperActive} sliderArr={sliderArr} modalStatus={modalStatus} setModalStatus={setModalStatus} /> : <GallerySliderModal swiperActive={swiperActive} setSwiperActive={setSwiperActive} sliderArr={sliderArr} modalStatus={modalStatus} setModalStatus={setModalStatus} scale={scale} setScale={setScale} />);
    $[47] = isMobile;
    $[48] = modalStatus;
    $[49] = scale;
    $[50] = sliderArr;
    $[51] = swiperActive;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t25 || $[54] !== t26) {
    t27 = <>{t25}{t26}</>;
    $[53] = t25;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  return t27;
};
function _temp(e) {
  return e.stopPropagation();
}